// extracted by mini-css-extract-plugin
export default {"wrapper":"UIEwjM_nhOGBOu4vV1ib","inner":"GNSwyRn_VpLlk5Z_Gq96","link":"V3pb28PN55LcapbuJ5Zi","is_active":"UoV022rCO0x9kQaArNbL","isActive":"UoV022rCO0x9kQaArNbL"};